import React from "react";
import "../styles/activated.css";
import { useNavigate } from "react-router-dom";
const ActivatedAccount =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/accountactivated.svg";
const Logo =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/logo.svg";
export default function AccountActivated() {
  const navigate = useNavigate();
  return (
    <div className="activatedhome">
      <img src={Logo} alt="Logo" className="activatedlogo" />
      <div className="activatedhomebg"></div>
      <div className="activatedmain">
        <img src={ActivatedAccount} alt="Account Activated" />
        <h1>Account Activated</h1>
        <p>
          Your account is now active! You can log in and start exploring all the
          features waiting for you. Enjoy the experience and make the most of
          it!
        </p>
        <button onClick={() => navigate("/login")}>Login</button>
      </div>
    </div>
  );
}
